module.exports = require("vue-demi");